module.exports = __webpack_public_path__ + "static/img/card_5_2.294efa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_5_2.png
// module id = rWW8
// module chunks = 0